// @flow
import glamorous from 'glamorous'

const SlideshowTrigger = glamorous
  .button({ width: '100%' })
  .withProps({ type: 'button', onMouseDown: e => e.preventDefault() })

export default SlideshowTrigger



// WEBPACK FOOTER //
// ./src/components/SlideshowTrigger.js